import {Icons} from "./icons";

export const Mode = new Map<number, {label: string, icon: string}>([
  [1, {label: 'course-mode-attendance', icon: Icons.LECTURE_MODES.PRESENCE}],
  [2, {label: 'course-mode-videoconference', icon: Icons.LECTURE_MODES.VIDEOCONFERENCE}],
  [3, {label: 'course-mode-recorded', icon: Icons.LECTURE_MODES.E_LEARNING}],
])